import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { selectCanManagePrivateWhiteboards } from 'features/permissions/permissionsSlice';
import { useAppSelector } from 'store/hooks';

export const useWhiteboard = () => {
  const featureEnabled = useFeatureFlag('whiteboard');

  const { hasPermissions } = usePermissions();

  const canManageEditWhiteboard = hasPermissions(PermissionTypes.manageEditWhiteboard);
  const canEditWhiteboard = hasPermissions(PermissionTypes.editWhiteboard);
  const canManagePrivateWhiteboards = useAppSelector(selectCanManagePrivateWhiteboards);

  const isFeatureAvailable =
    featureEnabled && (canManageEditWhiteboard || canEditWhiteboard || canManagePrivateWhiteboards);

  return {
    canEditWhiteboard,
    canManageEditWhiteboard,
    canManagePrivateWhiteboards,
    isFeatureAvailable,
  };
};
